import {createContext} from '@lit-labs/context';
import type {Team} from '#lit/types/teams.js';
import type {Audience} from '#lit/types/audiences.js';
import type {
  Dataset,
  DatasetGroup,
  SourceConnection,
} from '#lit/types/datasets.js';
import type {Nullable} from '#lit/types/general.js';
import type {QueueEvent} from '#lit/types/journeys.js';

export type EntryData = {
  datasets: Dataset[];
  dataset: Nullable<Dataset>;
  audience: Nullable<Audience>;
  sourceConnection: Nullable<SourceConnection>;
  team: Nullable<Team>;
  datasetGroup: Nullable<DatasetGroup>;
  /**
   * Indicates if the current journey context is realtime.
   * When true, components should use realtime field services.
   * Provided by criteria-node-configuration component.
   */
  isRealtimeJourney?: boolean;
  /**
   * The queue event data for realtime journeys.
   * Available when isRealtime is true.
   * Provided by criteria-node-configuration component.
   */
  queueEvent?: Nullable<QueueEvent>;
};

export const DEFAULT_ENTRY_DATA: EntryData = {
  datasets: [],
  dataset: null,
  audience: null,
  sourceConnection: null,
  datasetGroup: null,
  team: null,
  isRealtimeJourney: false,
  queueEvent: null,
};

export const EntryDataContext = createContext<EntryData>('entry-data-context');
